export const summaryItemsMappingTable: {[key: string]: string} = {
  'New + Upgraded ARR': '/data-input/contract-management/contracts?status=New,Upsell',
  'Out of Term': '/data-input/contract-management/contracts?status=Out%20of%20Term',
};
